module.exports = __webpack_public_path__ + "static/media/low.2d3305e4.svg";